import Chip from 'material-ui/Chip/Chip';

export default Chip;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Chip/index.ts